import { useEffect } from "react";

/**
 * Injects one or more JSON-LD structured data blocks into <head>.
 * Each block is tagged with data-jsonld-id={id} so it can be replaced
 * or cleaned up on unmount.
 */
export function useJsonLd(id: string, data: object | object[] | null | undefined) {
  useEffect(() => {
    if (!data) return;
    const blocks = Array.isArray(data) ? data : [data];

    // Remove any existing blocks with this id first (guards against duplicates on re-render).
    document.head
      .querySelectorAll(`script[type="application/ld+json"][data-jsonld-id="${id}"]`)
      .forEach((el) => el.remove());

    const elements = blocks.map((block, i) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-jsonld-id", id);
      script.setAttribute("data-jsonld-index", String(i));
      script.textContent = JSON.stringify(block);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      elements.forEach((el) => el.remove());
    };
  }, [id, data]);
}
